import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Badge } from 'foundations-components/transitional/components/Badge';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback } from 'react';
import useCloneTracker from '../../../../hooks/useCloneTracker';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { isReportValidForReportGetterStrategy } from 'reporting-ui-components/lib/report-strategies/utils/strategyFetchers';
import useFetchIsAIEnabledFromSettings from './useFetchIsAIEnabledFromSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportingAIAssistantInsightsContainer = ({
  report,
  appUsageTracker,
  children,
  isInsightsOpen,
  setIsInsightsOpen
}) => {
  const usageTracker = useCloneTracker(appUsageTracker);
  const isAIEnabledFromSettings = useFetchIsAIEnabledFromSettings();
  const isValidForReportGetterStrategy = isReportValidForReportGetterStrategy(report);
  const onOpenInsights = useCallback(() => {
    setIsInsightsOpen(!isInsightsOpen);
    usageTracker.track('reportingAIAssistantInsightsInteraction', {
      isOpen: !isInsightsOpen,
      action: 'openSummary',
      chartType: isValidForReportGetterStrategy ? getStandardFieldType(report, STANDARD_FIELD_TYPES.CHART_TYPE) : ''
    });
  }, [setIsInsightsOpen, isInsightsOpen, usageTracker, isValidForReportGetterStrategy, report]);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    marginBlock: "200",
    children: /*#__PURE__*/_jsx(AccordionItem, {
      open: isInsightsOpen,
      disabled: !isAIEnabledFromSettings,
      "data-test-id": "report-vis-insights-container",
      onOpenChange: onOpenInsights,
      paddingBlockStart: "400",
      paddingBlockEnd: "200",
      paddingInlineStart: "400",
      title: /*#__PURE__*/_jsxs(Flex, {
        inlineSize: "100%",
        paddingInline: "400",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexGrow: "1",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reporting-enablement.platformReport.reportVisualizationInsights.container.title"
            })
          }), /*#__PURE__*/_jsx(AIBadge, {}), /*#__PURE__*/_jsx(Badge, {
            use: "beta",
            marginInlineStart: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reporting-enablement.platformReport.reportVisualizationInsights.container.beta"
            })
          })]
        }), /*#__PURE__*/_jsx(Box, {
          shrink: "0",
          children: /*#__PURE__*/_jsx(Tooltip, {
            disabled: false,
            title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "reporting-enablement.platformReport.reportVisualizationInsights.container.generateButton.disabledTooltip_jsx",
              elements: {
                UILink: Link
              },
              options: {
                external: true,
                href: `/ai-settings/${PortalIdParser.get()}`,
                target: 'blank'
              }
            }),
            children: /*#__PURE__*/_jsx(AIButton, {
              featureCategoryId: "feature-enabled",
              disabled: !isAIEnabledFromSettings || isInsightsOpen,
              usageTracker: usageTracker,
              "data-test-id": "ai-button",
              size: "small",
              onClick: () => {
                setIsInsightsOpen(true);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: 'reporting-enablement.platformReport.reportVisualizationInsights.container.generateButton.generateLabel'
              })
            })
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(View, {
        padding: "300",
        children: children
      })
    })
  });
};
export default ReportingAIAssistantInsightsContainer;